import { render, staticRenderFns } from "./FormModuleList.vue?vue&type=template&id=4fac0684&"
import script from "./FormModuleList.vue?vue&type=script&lang=js&"
export * from "./FormModuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports